/* Common Imports */

import React from "react";
import { makeStyles } from "@material-ui/core/styles";

/* Component Imports */

import { Typography, Button } from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";

/* Data Imports */

import AppConfig from "../../../../AppConfig";

/* Define all styles */

const useStyles = makeStyles((theme) => ({
  shareButton: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    width: "50%",
    margin: "0rem 0.25rem 0rem 0rem",
    backgroundColor: "#FFFFFF",
    color: "#202020",
    textTransform: "capitalize",
  },
  downloadButton: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    width: "50%",
    margin: "0rem 0rem 0rem 0.25rem",
    background: "-webkit-linear-gradient(0deg, #F74134, #EB1C61)",
    color: "#FFFFFF",
    textTransform: "capitalize",
  },
  buttonText: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    fontWeight: 400,
    fontSize: "0.875rem",
    lineHeight: "1.3125rem",
  },
  buttonIcon: {
    margin: "0rem 0rem 0rem 0.5rem",
  },
  buttonContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
  },
  skeletonContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
  },
  buttonSkeleton: {
    width: "48%",
    height: "2rem",
    "&.MuiSkeleton-text": {
      transform: "none",
    },
  },
}));

const GridCardButtons = (props) => {
  const shareButtonClickListener = (event) => {
    event.preventDefault();
  };
  const pdfButtonClickListener = (event) => {
    event.preventDefault();
  };

  const classes = useStyles();

  if (!props.loading) {
    return (
      <React.Fragment>
        <div className={classes.buttonContainer}>
          <Button
            component="button"
            variant="contained"
            size="large"
            className={classes.shareButton}
            onClick={
              typeof props.shareButtonClickListener === "function"
                ? props.shareButtonClickListener
                : shareButtonClickListener
            }
          >
            <Typography
              variant="body2"
              component="span"
              className={classes.buttonText}
            >
              Share
              <img
                src="/images/icons/social/share.svg"
                alt={AppConfig.imageAltText}
                width={16}
                height={16}
                loading="lazy"
                referrerPolicy="no-referrer"
                className={classes.buttonIcon}
              />
            </Typography>
          </Button>
          <Button
            component="button"
            variant="contained"
            size="large"
            className={classes.downloadButton}
            onClick={
              typeof props.pdfButtonClickListener === "function"
                ? props.pdfButtonClickListener
                : pdfButtonClickListener
            }
          >
            <Typography
              variant="body2"
              component="span"
              className={classes.buttonText}
            >
              Download
              <img
                src="/images/icons/social/download-white.svg"
                alt={AppConfig.imageAltText}
                width={16}
                height={16}
                loading="lazy"
                referrerPolicy="no-referrer"
                className={classes.buttonIcon}
              />
            </Typography>
          </Button>
        </div>
      </React.Fragment>
    );
  } else {
    return (
      <React.Fragment>
        <div className={classes.skeletonContainer}>
          <Skeleton className={classes.buttonSkeleton} />
          <Skeleton className={classes.buttonSkeleton} />
        </div>
      </React.Fragment>
    );
  }
};

export default GridCardButtons;
